import styled from 'styled-components'
import { Card } from 'sutra/components/Card/Card'
import { Text } from 'sutra/components/Text/Text'
import { textSizeStyles } from 'sutra/components/Text/text-styles'
import { brand, gray } from 'sutra/tokens/colors'
import { radii } from 'sutra/tokens/radii'
import { spacing } from 'sutra/tokens/spacing'

const REFLECTION_BLUE_25 = '#EDF1F6'
const ICON_TILE_SIZE = 50

export const CardWrap = styled(Card)`
  width: 450px;
  flex-shrink: 0;
  align-self: flex-start;
  box-shadow: none;
  border: 1px solid #e9eaeb;
`

export const CardHeaderRow = styled.header`
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: ${spacing[5]}px;
`

export const IconTile = styled.div`
  width: ${ICON_TILE_SIZE}px;
  height: ${ICON_TILE_SIZE}px;
  border-radius: ${radii.sm}px;
  background: ${REFLECTION_BLUE_25};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const HeaderTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  /* Collapse dead space between sutra Text line-heights (28 + 20). */
  > *:not(:first-child) {
    margin-top: -6px;
  }
`

// styled(Text) drops `$size`, so TitleText, ScopeChip and EmptyChipText restate
// theirs in CSS; render with `forwardedAs`, since `as` would replace Text.
export const TitleText = styled(Text)`
  ${textSizeStyles.lg}
  font-weight: 600;
  color: ${brand.stillNight[800]};
`

export const Section = styled.section`
  margin-top: ${spacing[5]}px;
  &:first-of-type {
    margin-top: 0;
  }
`

export const SectionTitle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${brand.stillNight[800]};
  margin-bottom: ${spacing[2]}px;
`

export const SectionTitleText = styled(Text)`
  font-weight: 600;
  color: ${brand.stillNight[800]};
`

export const ChipRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]}px;
  align-items: flex-start;
`

// Rectangular chip — sutra Pill is a full pill. Local until sutra grows one.
export const ScopeChip = styled(Text)`
  display: inline-block;
  max-width: 100%;
  height: 24px;
  padding: 2px ${spacing[3]}px;
  background: ${gray[50]};
  border: 1px solid #e9eaeb;
  border-radius: ${radii.sm}px;
  ${textSizeStyles.sm}
  color: ${gray[700]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
`

export const EmptyChipText = styled(Text)`
  ${textSizeStyles.sm}
  font-style: italic;
`
